var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultFlowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 87,
    viewBox: "0 0 90 87",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 90,
    height: 86,
    rx: 12,
    fill: "url(#paint0_linear_9_8213)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7398 25.0723V36.1294H43.2463V41.658H32.7269C30.7808 41.658 29.2204 43.2981 29.2204 45.3437V50.8723H25.7139V61.9294H36.2333V50.8723H32.7269V45.3437H43.2463V50.8723H39.7398V61.9294H50.2593V50.8723H46.7528V45.3437H57.2723V50.8723H53.7658V61.9294H64.2853V50.8723H60.7788V45.3437C60.7788 43.2981 59.2184 41.658 57.2723 41.658H46.7528V36.1294H50.2593V25.0723H39.7398Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9_8213",
    x1: 3.32661,
    y1: 43.5,
    x2: 90.1814,
    y2: 43.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7445FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#62D9FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFlowIcon);
export default __webpack_public_path__ + "static/media/default-flow-icon.98d4c3f2746eb4da46f87d5affff21ef.svg";
export { ForwardRef as ReactComponent };